import React from 'react';
import { ChatMessage as Message } from './ChatMessage';
import { LoadingSpinner } from '../common/Loading';
import { ErrorMessage } from '../common/Error';
import type { ChatMessage } from '../../types/chat';

interface ChatMessagesProps {
  messages: ChatMessage[];
  isLoading: boolean;
  error: string | null;
}

export const ChatMessages: React.FC<ChatMessagesProps> = ({ messages, isLoading, error }) => {
  if (error) {
    return <ErrorMessage message={error} />;
  }

  return (
    <div className="space-y-4">
      {messages.map((message, index) => (
        <Message key={index} message={message} />
      ))}
      
      {isLoading && (
        <div className="flex justify-center">
          <LoadingSpinner />
        </div>
      )}
      
      {messages.length === 0 && !isLoading && (
        <div className="text-center text-purple-200/70 mt-8">
          Olá! Como posso ajudar você hoje? ✨
        </div>
      )}
    </div>
  );
};